// extracted by mini-css-extract-plugin
module.exports = {"bf-icon":"bf-icon__rMfaQ","low-icon":"low-icon__zUcLI","medium-icon":"medium-icon__j5ubR","high-icon":"high-icon__TD9C6"};